import * as deepMerge from 'deepmerge';

export function removeNullOrUndefined<T extends { [key: string]: any } = {}>(input: T = {} as T): Partial<T> {
	const output = deepMerge<T>({}, input);

	Object.keys(output).forEach((key) => {
		const obj = output[key];

		if (typeof obj === 'object' && obj !== null) {
			if (obj instanceof Date) { }
			else if (obj instanceof RegExp) { }
			else {
				output[key].value = removeNullOrUndefined(obj);
			}
		} else if (obj === null || typeof obj === 'undefined') {
			delete output[key];
		}
	});

	return output;
}
